/**
 * ステート管理用のStore
*/
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';//非同期処理用
import rootReducer from './reducers';
import { persistStore } from 'redux-persist';

const middleware = [thunk];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

//ストアを作成
const store = createStore(
    rootReducer,
    //ミドルウェア登録。現状はthunkのみ
    composeEnhancers(applyMiddleware(...middleware))
);

export default store;
export const persistor = persistStore(store);